<template>
  <v-row>
    <v-col cols="12">
      <v-data-table :headers="headers" :items="items" dense hide-default-footer disable-pagination>
        <template v-slot:item.no="{ index }">
          {{ index + 1 }}
        </template>
        <template v-slot:item.total="{ item }">
          {{ formatPrice(item.total) }}
        </template>
        <template v-slot:item.totalAmountJournal="{ item }">
          {{ formatPrice(item.totalAmountJournal) }}
        </template>
        <template v-slot:item.different="{ item }">
          {{ formatPrice(item.different) }}
        </template>
        <template v-slot:item.action="{ item }">
          <v-row>
            <v-col cols="12">
              <v-btn color="primary" @click="detail(item)"><v-icon>mdi-eye</v-icon></v-btn>
            </v-col>
          </v-row>
        </template>
      </v-data-table>
    </v-col>

    <reconciliation-detail
      :dialog="dialog"
      :items="details"
      :type="type"
      @close="close"
    ></reconciliation-detail>
  </v-row>
</template>

<script>
import ReconciliationDetail from "./ReconciliationDetail.vue";

export default {
  name: "report-reconciliation-ap",
  components: {
    ReconciliationDetail,
  },
  props: {
    items: Array,
    type: String,
  },
  data() {
    return {
      details: [],
      dialog: false,
      headers: [
        {
          text: "No",
          align: "center",
          sortable: false,
          value: "no",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          text: "Vendor",
          value: "vendorName",
          sortable: false,
          align: "center",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          text: "Total Reconciliation",
          value: "total",
          sortable: false,
          align: "center",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          text: "Total GL",
          value: "totalAmountJournal",
          sortable: false,
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          text: "Different",
          value: "different",
          sortable: false,
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          text: "Status",
          value: "status",
          sortable: false,
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          text: "Action",
          value: "action",
          sortable: false,
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
      ],
    };
  },
  methods: {
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    detail(item) {
      this.details = item.items;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
  },
};
</script>

<style></style>
